import { getBearerTokenServerAction } from '@sylveraio/auth-utils/server-only'
import { HUXLEY_API_HEADERS, REVALIDATION_SECONDS } from '@sylveraio/constants'

import { client } from './generated/client.gen'

const BASE_URL = process.env.NEXT_PUBLIC_MONARCH_API_URL

client.setConfig({
  baseUrl: BASE_URL,
})

client.interceptors.request.use(
  async (request: Request & RequestInit, _options) => {
    const bearerToken = await getBearerTokenServerAction()

    request.headers.set('Authorization', `Bearer ${bearerToken}`)

    Object.entries(HUXLEY_API_HEADERS).forEach(([key, value]) => {
      request.headers.set(key, value)
    })

    // eslint-disable-next-line no-param-reassign
    request.next = { revalidate: REVALIDATION_SECONDS }
    return request
  },
)

export * from './generated'
